import { isAfter } from 'date-fns'

import {
  MatchItem,
  OptaMatchItemTeam,
  OptaTeamStanding,
} from '@sportworld/js-sdk/src/types/soccerDataTypes'
import { getSoccerTeamLogo } from '@sportworld/js-sdk/src/utils/soccerData'

import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import {
  CellWithIcon,
  ColumnHeader,
  Icon,
  PointsCell,
  ScoreItem,
  ScoreWrapper,
  TableHeader,
  Title,
} from './styles'
import type { Columns } from './types'

export const renderTableHeader = <T = any,>(
  columns: Columns<T>,
  t: ReturnType<typeof useCommonTranslation>['t'],
  keySuffix?: string | number,
) => (
  <TableHeader>
    {columns?.map((column) => {
      const key = column.title + keySuffix

      return (
        <ColumnHeader key={key} $width={column.width}>
          {t(column.title)}
        </ColumnHeader>
      )
    })}
  </TableHeader>
)

export const teamRender = (team: OptaTeamStanding) => (
  <CellWithIcon>
    <Icon
      src={getSoccerTeamLogo(team.contestantId)}
      alt={team.contestantName}
    />
    <Title>{team.contestantName}</Title>
  </CellWithIcon>
)

export const renderPoints = (team: OptaTeamStanding) => (
  <PointsCell>{team.points}</PointsCell>
)

export const renderTeamCell = (team: OptaMatchItemTeam, revert = false) => (
  <CellWithIcon $isRevert={revert} $tall>
    <Icon src={getSoccerTeamLogo(team.id)} alt={team.name} />
    <Title>{team.name}</Title>
  </CellWithIcon>
)

export const renderMatchScore = (match: MatchItem) => {
  const startsAt = new Date(match.startsAt)
  const isDateAfter = isAfter(startsAt, new Date())
  const homeScore = isDateAfter ? '-' : match.score?.home
  const awayScore = isDateAfter ? '-' : match.score?.away

  return (
    <ScoreWrapper>
      <ScoreItem $stretch>{homeScore}</ScoreItem>
      <ScoreItem>:</ScoreItem>
      <ScoreItem $stretch>{awayScore}</ScoreItem>
    </ScoreWrapper>
  )
}
